var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-modal", {
    attrs: {
      modalTitle: _vm.title,
      showSpinner: _vm.isLoading,
      showModal: _vm.showModal,
      "loading-primary-footer-button": _vm.isLoading,
      modalLarge: true,
      showSecondaryFooterButton: false,
      showPrimaryFooterButton: false,
    },
    on: _vm._d({}, [_vm.closeEvent, _vm.onCloseButtonClicked]),
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "d-flex justify-content-end" }, [
              _c("div", { staticClass: "portal-meta-chip" }, [
                _c("i", {
                  staticClass: "far fa-calendar-alt",
                  attrs: { "aria-hidden": "true" },
                }),
                _c(
                  "span",
                  [
                    _vm._v(_vm._s(_vm.dayName) + ", "),
                    _c("formatted-date-component", {
                      attrs: { val: _vm.date },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _c("vue-data-table", {
              attrs: {
                tableColumns: _vm.columns,
                tableRows: _vm.rows,
                showRowTableAction: false,
                "empty-rows-message": _vm.$t("components.table.no_data"),
              },
              scopedSlots: _vm._u([
                {
                  key: "table-row",
                  fn: function (props) {
                    return [
                      props.cell.getColumn.id == "firstPartStartingTime"
                        ? [
                            _c(
                              "div",
                              {
                                class: {
                                  "font-weight-bold": _vm.isCurrentWeekDay(
                                    props.cell.getRaw.weekDay
                                  ),
                                },
                              },
                              [
                                _c("formatted-date-component", {
                                  attrs: {
                                    val: props.cell.getRaw
                                      .firstPartStartingTime,
                                    withoutDate: true,
                                    withTime: true,
                                  },
                                }),
                                _c("span", [_vm._v(" - ")]),
                                _c("formatted-date-component", {
                                  attrs: {
                                    val: props.cell.getRaw.firstPartEndingTime,
                                    withoutDate: true,
                                    withTime: true,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : props.cell.getColumn.id == "secondPartStartingTime"
                        ? [
                            _c(
                              "div",
                              {
                                class: {
                                  "font-weight-bold": _vm.isCurrentWeekDay(
                                    props.cell.getRaw.weekDay
                                  ),
                                },
                              },
                              [
                                _c("formatted-date-component", {
                                  attrs: {
                                    val: props.cell.getRaw
                                      .secondPartStartingTime,
                                    withoutDate: true,
                                    withTime: true,
                                  },
                                }),
                                _c("span", [_vm._v(" - ")]),
                                _c("formatted-date-component", {
                                  attrs: {
                                    val: props.cell.getRaw.secondPartEndingTime,
                                    withoutDate: true,
                                    withTime: true,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : props.cell.getColumn.id == "weekDay"
                        ? [
                            _c(
                              "div",
                              {
                                class: {
                                  "font-weight-bold": _vm.isCurrentWeekDay(
                                    props.cell.getRaw.weekDay
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.dayTranslation(props.cell.getValue)
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        : [
                            _c(
                              "div",
                              {
                                class: {
                                  "font-weight-bold": _vm.isCurrentWeekDay(
                                    props.cell.getRaw.weekDay
                                  ),
                                },
                              },
                              [_vm._v(" " + _vm._s(props.cell.getValue) + " ")]
                            ),
                          ],
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }